import React from "react";
import { Container, Row, Col } from "reactstrap";
import GridBody from "./Grid/GridBody";
import withRouter from "../../../components/Common/withRouter";
import { useLocation } from "react-router-dom";
import { CardGridCustom } from "../../../components/Common/CardGridCustom";

function DF_OT0051(props) {
  document.title = "Defender | Cadastro Local de Entrega";

  const location = useLocation();
  const idEmpresa = location.state?.idEmpresa ?? null;

  return (
    <>
      <div
        className="page-content"
        style={{ backgroundColor: "#f4f5f7", minHeight: "100vh" }}
      >
        <Container fluid={true} className="dataTable-custom-primary">
          <Row className="mb-2">
            <Col lg={12}>
              <h4 className="font-size-24 font-w-600 text-color-azul1 mb-4">
                Cadastro Local de Entrega
              </h4>

              <CardGridCustom>
                <GridBody idEmpresa={idEmpresa} />
              </CardGridCustom>
            </Col>
          </Row>
        </Container>
      </div>
    </>
  );
}

export default withRouter(DF_OT0051);